module.exports = __webpack_public_path__ + "/images/logo-cta-diari-tarragona.67a1dbd.png";